export const validatorRegexes = {
  name: /^[A-Za-z\-.' ]+$/,
};

export const flattenErrors = (errors: any) => {
  const flattened: any = {};

  const flatten = (obj: any, prefix = '') => {
    Object.keys(obj).forEach((key) => {
      const newKey = prefix ? `${prefix}.${key}` : key;

      // Check if the value is a string or non-object, non-array
      if (
        typeof obj[key] === 'string' ||
        typeof obj[key] === 'number' ||
        typeof obj[key] === 'boolean'
      ) {
        flattened[newKey] = obj[key]; // Directly add the string/number/boolean to flattened
      } else if (
        typeof obj[key] === 'object' &&
        !Array.isArray(obj[key]) &&
        obj[key] !== null
      ) {
        flatten(obj[key], newKey); // Recursively flatten nested objects
      }
    });
  };

  flatten(errors); // Call flatten function with the root object

  // Remove any duplicate "dependants." prefix from flattened keys
  Object.keys(flattened).forEach((key) => {
    const newKey = key.replace(/^dependants\.dependants\./, 'dependants.');
    if (newKey !== key) {
      flattened[newKey] = flattened[key];
      delete flattened[key];
    }
  });

  return flattened;
};
